
type MessageErrorFieldProps = {
  name?: string;
  message?: string;
};

export const MessageErrorField: React.FC<MessageErrorFieldProps> = ({
  name,
  message,
}) => {

  if (!message) return <></>;

  return (
    <div className="text-danger mt-2" data-error-test={name}>
      {message}
    </div>
  );
};
